import { network } from 'services/network';

export const getCardComment = (params) => {
    const url = `api/bo/getCardComment?cardId=${params.id}&isVirtual=${params.isVirtual}`;

    return network.post(url).then((response) => {
        return response.data;
    });
};
